import type { TSerializedWidget } from 'src/entities/workspace/types';
import type { DrillingMultiAnalysisWidgetEntity } from 'src/pages/dashboard/features/drilling-multi-analysis-widget/DrillingMultiAnalysisWidget.entity';
import { parseDrillingMultiAnalysisWidgetInternalState } from 'src/pages/dashboard/features/drilling-multi-analysis-widget/parseDrillingMultiAnalysisWidget';

import { baseWidgetApplyChanges } from './baseWidgetApplyChanges';

export function drillingMultiAnalysisApplyChanges(
  widget: DrillingMultiAnalysisWidgetEntity,
  changes: TSerializedWidget,
  index: number,
) {
  baseWidgetApplyChanges(widget, changes, index);

  const internalState = parseDrillingMultiAnalysisWidgetInternalState(changes.internalState ?? {});

  widget.setWellId(internalState.wellId);
  widget.setStateParams(internalState.stateParams);
}
